import { render, staticRenderFns } from "./ShorcutsComponent.vue?vue&type=template&id=afbfc12e&scoped=true"
import script from "./ShorcutsComponent.vue?vue&type=script&lang=js"
export * from "./ShorcutsComponent.vue?vue&type=script&lang=js"
import style0 from "./ShorcutsComponent.vue?vue&type=style&index=0&id=afbfc12e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbfc12e",
  null
  
)

export default component.exports